module.exports = __webpack_public_path__ + "1243dec1ecb41a98815a8ca3a8c2f79e.png";